<template>
  <div id="client_complete">
    <dd-header />
    <div class="wrapper">
      <div class="main_content">
        <dd-menu ref="menuRef"/>
        <div>
          <dd-sitemap
            :pageKey="pageKey"
            :pageList="pageList"
            :mapStyle="'topic_path'"
          />
          <div>
            お申込みありがとうございます。審査にお⽇にちがかかる場合がございます。<br>
            審査結果はご登録したメールアドレスに送信されます。
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '../components/common/DcHeader'
import LeftMenu from '../components/top/DcLeftMenu'
import Footer from '../components/common/DcFooter'
import SiteMap from '../components/common/DcSiteMap'

export default {
  name: 'ClientComplete',
  components: {
    'dd-header': Header,
    'dd-menu': LeftMenu,
    'dd-footer': Footer,
    'dd-sitemap': SiteMap
  },
  data () {
    return {
      pageKey: 'dcClientComplete',
      pageList: [
        {id: 'top', key: 'dcTop', title: 'トップページ', route: 'DcTop'},
        {id: 'dcClientComplete', key: 'dcClientComplete', title: '顧客情報完了', route: 'DcClientComplete'}
      ]
    }
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  created () {
  }
}
</script>



// WEBPACK FOOTER //
// src/main/js/payment/pages/DcClientComplete.vue